import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import applyReducer from './applyReducer';
import { constantsRegistry } from '../constants/tableConstantsFactory';
import changeReducerFactory from './factories/changeReducerFactory';
import detailReducerFactory from './factories/detailReducerFactory';
import entityReducerFactory from './factories/entityReducerFactory';
import uploadReducerFactory from './factories/uploadReducerFactory';
const changeReducer = changeReducerFactory('asset');
const detailReducer = detailReducerFactory('asset');
const entityReducer = entityReducerFactory('asset');
const uploadReducer = uploadReducerFactory('asset');
const assetConstants = constantsRegistry('asset');
const defaultIndexQuery = _objectSpread(_objectSpread({}, entityReducer.initState.indexQuery), {}, {
  filters: {
    text: '',
    status: '',
    jobs: [],
    organizations: []
  }
});
const duplicateSuccess = (state, _ref) => {
  let data = _ref.data;
  const list = state.list;
  const updatedList = list.concat(data);
  return _objectSpread(_objectSpread({}, state), {}, {
    list: updatedList
  });
};
const initState = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, entityReducer.initState), changeReducer.initState), detailReducer.initState), uploadReducer.initState), {}, {
  indexQuery: defaultIndexQuery,
  initialIndexQuery: defaultIndexQuery,
  permissions: {
    view: {
      include: ['asset_admin']
    },
    edit: {
      include: ['asset_admin']
    }
  }
});
const reducers = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeReducer.reducers), detailReducer.reducers), entityReducer.reducers), uploadReducer.reducers), {}, {
  [assetConstants.DUPLICATE_SUCCESS]: duplicateSuccess
});
export default applyReducer(reducers, initState);